<template>
  <div class="shadow_nr" v-show="pullBox" v-on:click="cancelpullBox(false)" style="z-index: 999999">
    <div class="shadow-cont" v-on:click="clickTest">
      <div class="album-list">
        <ul class="clear">
          <li @click="copy">复制</li>
          <li @click="report">举报
          </li>
          <li @click="addToBlackList">加入黑名单</li>
        </ul>
      </div>
      <div class="cancel cancel1" @click="cancelpullBox(false)">取消</div>
    </div>
    <div ref="copyStr" v-html="item.content" style="display:none;position: absolute; left: -100px">
    </div>
    <add-black-list :uid="item.creator ? item.creator.id.toString() : '-1' "
                    ref="blackList"></add-black-list>
  </div>
</template>

<script>
  import { copy } from '@/assets/js/util'
  import router from '@/router'
  import addBlackList from '@/components/tools/addBlackList'

  export default {
    components: {
      addBlackList
    },
    data () {
      return {
        pullBox: false,
        item: {},
        func: null
      }
    },
    methods: {
      cancelpullBox (val) {
        this.pullBox = val
      },
      clickTest (e) {
        e.stopPropagation()
      },
      clickSelectImage () {
        this.$router.push('/releaseMessage')
      },
      setItem (o) {
        this.item = o
      },
      copy () {
        copy(this.$refs.copyStr.innerText)
        this.pullBox = false
        this.$tips('复制成功', 3000)
      },
      report () {
        router.push(`/postReport/${this.item.id}`)
        this.pullBox = false
      },
      addToBlackList () {
        this.$refs.blackList.open()
      }
    }
  }
</script>

<style lang="less" scoped>
  /*......朋友圈隐藏下拉........*/
  .album-list {
    border-bottom: 10px solid #f2f2f2;
  }

  .album-list ul li {
    text-align: center;
    line-height: 40px;
    border-bottom: 1px solid #f0f0f0;
    font-size: 17px;
  }

  .album-list ul li p {
    color: #999;
    line-height: 0;
    margin-bottom: 17px;
  }

  .cancel1 {
    color: #333;
  }
  .shadow_nr {
    width: 200px;
    height: 200px;
    position: absolute;
    border: 1px solid #404040;
    border-radius: 20px;
    top: 230px;
    right: 0;
    z-index: 200;
    overflow-y: hidden;
  }
</style>



// WEBPACK FOOTER //
// src/components/base/pulldown/pulldown.vue